import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import PodpisBlok from './PodpisBlok';
import { btnOutline, btnPrimary, chyboveHlaseni, apiChyba } from '../ui';

const API = process.env.REACT_APP_API_URL || '/api';

// Celoobrazovkový náhled protokolu (stejná data jako PDF – GET .../protokol/nahled) a podpis na místě.
// onHotovo: podepsáno; onZavrit: zavřeno bez podpisu (rodič zobrazí upozornění).
export default function PodpisNaMiste({ aktivita, onHotovo, onZavrit }) {
  const ref = useRef(null);
  const [nahled, setNahled] = useState(null);
  const [chyba, setChyba] = useState(null);
  const [stav, setStav] = useState({ jmeno: false, podpis: false });
  const [ukladam, setUkladam] = useState(false);

  const nacti = () => {
    setNahled(null);
    axios.get(`${API}/aktivity/${aktivita.id}/protokol/nahled`).then(r => { setNahled(r.data); setChyba(null); })
      .catch(e => setChyba(apiChyba(e, 'Protokol se nepodařilo načíst.')));
  };
  useEffect(nacti, [aktivita.id]);

  // pozadí za náhledem se neposouvá
  useEffect(() => {
    const puvodni = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => { document.body.style.overflow = puvodni; };
  }, []);

  const podepsat = async () => {
    const h = ref.current.hodnoty();
    if (h.chyba) { setChyba(h.chyba); return; }
    setUkladam(true);
    try {
      await axios.put(`${API}/aktivity/${aktivita.id}/podpis`, { podepsal_jmeno: h.jmeno, podpis: h.podpis, otisk: nahled.otisk });
      onHotovo();
    } catch (e) {
      setChyba(apiChyba(e, 'Podpis se nepodařilo uložit.'));
      setUkladam(false);
    }
  };

  const sekce = { margin: '16px 0 4px', fontSize: '14px', fontWeight: 'bold', color: '#333' };
  const text = { whiteSpace: 'pre-wrap', fontSize: '16px', lineHeight: 1.4 };
  const pripraveno = nahled && stav.jmeno && stav.podpis && !ukladam;

  return (
    <div style={{ position: 'fixed', inset: 0, zIndex: 2000, background: '#f3f4f6', display: 'flex', flexDirection: 'column' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '10px 14px', background: '#fff', borderBottom: '1px solid #e5e7eb' }}>
        <strong style={{ fontSize: '16px' }}>Protokol k podpisu</strong>
        <button style={{ ...btnOutline, minHeight: '40px', padding: '6px 14px' }} onClick={onZavrit} disabled={ukladam}>✕ Zavřít</button>
      </div>

      <div style={{ flex: 1, overflowY: 'auto', WebkitOverflowScrolling: 'touch', padding: '14px' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          {!nahled && !chyba && <p>Načítám protokol…</p>}
          {!nahled && chyba && <><div style={chyboveHlaseni}>{chyba}</div><button style={btnOutline} onClick={nacti}>Zkusit znovu</button></>}
          {nahled && (
            <>
              <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '16px' }}>
                <h2 style={{ margin: 0, textAlign: 'center', color: '#333' }}>{nahled.nadpis}</h2>
                <div style={{ textAlign: 'center', color: '#555', margin: '2px 0 12px' }}>Objednávka: {nahled.obj} · výjezd č. {nahled.cislo_vyjezdu}</div>
                <div style={{ border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden' }}>
                  {nahled.radky.map((r, i) => (
                    <div key={r.popisek} style={{ display: 'flex', flexWrap: 'wrap', gap: '4px 12px', padding: '8px 10px', background: i % 2 ? '#fff' : '#f5f5f5', borderTop: i ? '1px solid #e2e8f0' : 'none' }}>
                      <span style={{ fontWeight: 'bold', flex: '0 0 160px' }}>{r.popisek}</span>
                      <span style={{ flex: '1 1 200px' }}>{r.hodnota}</span>
                    </div>
                  ))}
                </div>
                <div style={sekce}>Popis problému</div>
                <div style={text}>{nahled.popis_problemu}</div>
                <div style={sekce}>Provedené řešení</div>
                <div style={text}>{nahled.reseni}</div>
                <div style={sekce}>Použité zboží</div>
                {nahled.zbozi.length === 0 ? <div style={text}>Žádné zboží nebylo použito.</div> : (
                  <div style={{ border: '1px solid #e2e8f0', borderRadius: '6px', overflow: 'hidden' }}>
                    {nahled.zbozi.map((z, i) => (
                      <div key={i} style={{ display: 'flex', justifyContent: 'space-between', gap: '12px', padding: '8px 10px', borderTop: i ? '1px solid #e2e8f0' : 'none' }}>
                        <span>{z.polozka}</span><strong style={{ whiteSpace: 'nowrap' }}>{z.mnozstvi}</strong>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '10px', padding: '16px', marginTop: '14px' }}>
                <div style={{ ...sekce, marginTop: 0 }}>Potvrzení za prodejnu</div>
                <div style={{ fontSize: '14px', color: '#6b7280' }}>Podpisem potvrzujete, že jste si protokol přečetli.</div>
                <PodpisBlok ref={ref} onZmena={setStav} />
              </div>
              {chyba && <div style={chyboveHlaseni}>{chyba}{chyba.includes('změnil') && <> <button style={{ ...btnOutline, minHeight: '36px', padding: '4px 10px' }} onClick={nacti}>Načíst znovu</button></>}</div>}
            </>
          )}
        </div>
      </div>

      <div style={{ padding: '10px 14px calc(10px + env(safe-area-inset-bottom))', background: '#fff', borderTop: '1px solid #e5e7eb' }}>
        <div style={{ maxWidth: '760px', margin: '0 auto' }}>
          <button style={{ ...btnPrimary, width: '100%', opacity: pripraveno ? 1 : 0.5 }} onClick={podepsat} disabled={!pripraveno}>
            {ukladam ? 'Ukládám…' : '✍️ Podepsat'}
          </button>
        </div>
      </div>
    </div>
  );
}
